import { useQuery } from "@apollo/client";
import { useState } from "react";
import { GET_NPS_INFO } from "../../../../queries";

const ReviewReport = () => {
  const { data } = useQuery(GET_NPS_INFO);
  const [commentCount, setCommentCount] = useState(5);

  const rating = data?.totalFavoriteNumberPerEvaluation
    ? Object.entries(JSON.parse(data?.totalFavoriteNumberPerEvaluation)).sort(
        (a, b) => {
          return Number(b[0]) - Number(a[0]);
        }
      )
    : null;

  return (
    <div
      style={{
        padding: "50px 50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "white",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "20px 25px",
          borderRadius: "5px",
          border: "1px solid #DBDBDB",
          width: "100%",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          お気に入りされた数
        </div>
        <div
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginLeft: "50px",
          }}
        >
          {data?.totalFavoriteNumber ?? 0}
        </div>
      </div>
      <div className="chart-container">
        <div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            評価
          </div>
          <div
            style={{
              marginTop: "22px",
            }}
          >
            {rating &&
              rating.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 3fr 1fr",
                      marginBottom: "12px",
                      gap: "12px",
                      fontWeight: "500",
                    }}
                  >
                    <div>{`星${item[0]}つ`}</div>
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "20px",
                        borderRadius: "2px",
                        backgroundColor: "#F0F0F0",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: `${item[1]}%`,
                          height: "100%",
                          borderRadius: "2px",
                          backgroundColor: "#F6B572",
                        }}
                      />
                    </div>
                    <div>{`${item[1]}%`}</div>
                  </div>
                );
              })}
          </div>
        </div>
        <div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            コメント
          </div>
          <div
            style={{
              marginTop: "22px",
              borderRadius: "4px",
              border: "1px solid #DBDBDB",
              padding: "20px",
              paddingBottom: "0",
            }}
          >
            {data?.nps?.slice(0, commentCount)?.map((item, idx) => {
              return (
                <div
                  key={idx}
                  style={{
                    marginBottom: "20px",
                    paddingBottom: "20px",
                    borderBottom: "1px solid #DBDBDB",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                        fontWeight: "bold",
                      }}
                    >
                      <span>{item?.age}</span>
                      <span>{item?.sex}</span>
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#767676",
                        fontWeight: "5000",
                      }}
                    >
                      {item?.createdAt}
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "14px",
                    }}
                  >
                    {item?.comment}
                  </div>
                </div>
              );
            })}
          </div>
          {data?.nps?.length > commentCount && (
            <button
              onClick={() => setCommentCount(commentCount + 5)}
              style={{
                width: "100%",
                marginTop: "12px",
                padding: "8px 0",
                borderRadius: "4px",
                border: "1px solid #DBDBDB",
                backgroundColor: "white",
              }}
            >
              もっと見せる
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewReport;
